import {Injectable} from '@angular/core'
import {Observable} from 'rxjs/Observable'

@Injectable()
export class AuthenticationServiceMock {

  public getAuthenticatedUser(){
    return null
  }

  public logout() {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/authentication.service.mock.ts